import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  EmployeeRoleId,
  getEmployeeRoleBadgeClass,
  getEmployeeRoleLabel
} from '../../employee-role.utils';

@Component({
  selector: 'app-employee-role-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="role-badge" [ngClass]="badgeClass">
      {{ label }}
    </span>
  `,
  styleUrls: ['./employee-role-badge.component.css']
})
export class EmployeeRoleBadgeComponent {
  @Input() roleId: EmployeeRoleId = null;

  get label(): string {
    return getEmployeeRoleLabel(this.roleId);
  }

  get badgeClass(): string {
    return getEmployeeRoleBadgeClass(this.roleId);
  }
}